import ax from '@utils/axios'
import { useUserStore } from '@stores/users'

async function getMetrics() {
  const userStore = useUserStore()
  let partnerPromise = {}
  if (userStore.user.role !== 'partner') {
    // if the user is a vendor, load all partners
    partnerPromise = ax.get('/v2/partners')
    const vendorPromise = ax.get(`/v2/vendors/${userStore.vendorId}/linkedin-creatives`)
    await Promise.all([partnerPromise, vendorPromise]).then(values => {
      this.partners = values[0].data
      this.vendor = values[1].data
    })
  }
  else {
    // otherwise just load one partner
    partnerPromise = ax.get(`/v2/partners/${userStore.partnerId}/reporting_data`)
    await Promise.all([partnerPromise]).then(values => {
      this.partners = [{
        id: userStore.partner.id,
        platform: 'linkedin',
        name: 'placeholder',
        imgHref: 'placeholder'
      }]
      this.vendor = values[0].data
    })
  }
}

export default {
  getMetrics,
}
